import React from 'react';
import {InputNumber} from "antd";
import {DG_Format_Money} from "../../../format/Money";

const DG_InputNumber_Money = props => {
    return (
        <InputNumber
            max={Number.MAX_VALUE}
            formatter={DG_Format_Money}
            parser={(value) =>
                value.replace(/\$\s?|(,*)/g, "")
            }
            style={{width: '100%'}}

            {...props}
        />
    )
};


export default DG_InputNumber_Money;
